// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-user-message-box-parent-container{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
}
.customer-user-message-box-container{
    width: 25vw;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}
.customer-user-message-box-header{
    display: flex;
    color: white;
    padding: 10px 15px;
    justify-content: space-between;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.customer-user-message-box-header p{
    margin: 0px;
}
.customer-user-message-box-close-icon{
    cursor: pointer;
}
.customer-user-message-box-body{
    padding: 15px 20px;
}
.customer-user-message-box-body p{
    margin: 0px;
    padding: 0px;
    font-size: 15px;
    margin-top: 10px;
}
.customer-user-message-box-buttons-container{
    margin: 0px;
    text-align: right;
    padding-bottom: 15px;
}
.customer-user-message-box-buttons-container button{
    margin-right: 20px;
    padding: 8px 12px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-message-box-buttons-container button:hover{
    background-color: rgba(200, 50, 50, 0.952);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/CustomerUserMessageBox.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,YAAY;IACZ,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,sCAAsC;AAC1C;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;IACI,0CAA0C;AAC9C","sourcesContent":[".customer-user-message-box-parent-container{\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    height: 100vh;\n    width: 100vw;\n    background-color: rgba(0, 0, 0, 0.45);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.customer-user-message-box-container{\n    width: 25vw;\n    border-radius: 5px;\n    background-color: white;\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n}\n.customer-user-message-box-header{\n    display: flex;\n    color: white;\n    padding: 10px 15px;\n    justify-content: space-between;\n    border-radius: 5px 5px 0px 0px;\n    background-color: rgba(155, 30, 30, 0.952);\n}\n.customer-user-message-box-header p{\n    margin: 0px;\n}\n.customer-user-message-box-close-icon{\n    cursor: pointer;\n}\n.customer-user-message-box-body{\n    padding: 15px 20px;\n}\n.customer-user-message-box-body p{\n    margin: 0px;\n    padding: 0px;\n    font-size: 15px;\n    margin-top: 10px;\n}\n.customer-user-message-box-buttons-container{\n    margin: 0px;\n    text-align: right;\n    padding-bottom: 15px;\n}\n.customer-user-message-box-buttons-container button{\n    margin-right: 20px;\n    padding: 8px 12px;\n    border: none;\n    border-radius: 5px;\n    color: white;\n    cursor: pointer;\n    background-color: rgba(155, 30, 30, 0.952);\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\n    transition: background-color 0.5s ease;\n}\n.customer-user-message-box-buttons-container button:hover{\n    background-color: rgba(200, 50, 50, 0.952);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
